module.exports = __webpack_public_path__ + "img/history.28349f84.png";